import $ from 'jquery';
import { debounce } from '@github/mini-throttle';
const GIFT_NOTE_CONTAINER = '.js-cart-gift-note';
const GIFT_NOTE_TOGGLE = '.js-cart-gift-note-toggle';
const GIFT_NOTE_EDIT = '.js-cart-gift-note-edit-message';
const GIFT_NOTE_BUTTON = '.js-cart-gift-note-button';
const GIFT_NOTE_NOTICE = '.js-cart-gift-note-notice';
const GIFT_NOTE_TEXT_AREA = '.js-cart-gift-note-textarea';
const GIFT_NOTE_TEXT_AREA_NOTICE = '.js-cart-gift-note-textarea-notice';
const GIFT_NOTE_TEXT_AREA_COUNTER = '.js-cart-gift-note-counter';
export const init = async function() {
    const updateNoteCart = (cart_note)=>{
        const note = cart_note;
        $.ajax({
            type: 'POST',
            url: '/cart/update.json',
            data: {
                note: note
            },
            dataType: 'application/json'
        });
    };
    const checkNote = (textarea)=>{
        const cart_note = String(textarea.val() || '').trim();
        updateNoteCart(cart_note);
        if (cart_note === '') {
            $(GIFT_NOTE_NOTICE).addClass('u-vhide');
        } else {
            $(GIFT_NOTE_NOTICE).removeClass('u-vhide');
        }
        $(GIFT_NOTE_TEXT_AREA_NOTICE).css('visibility', 'visible').css('opacity', '1');
        setTimeout(()=>{
            $(GIFT_NOTE_TEXT_AREA_NOTICE).css('visibility', 'visible').css('opacity', '0');
        }, 3000);
    };
    const updateTextareaExpanded = ()=>{
        const isExpanded = $(GIFT_NOTE_TOGGLE).attr('aria-expanded') === 'true';
        $(GIFT_NOTE_TOGGLE).attr('aria-expanded', !isExpanded ? 'true' : 'false');
        $(GIFT_NOTE_EDIT).attr('aria-expanded', !isExpanded ? 'true' : 'false');
        $(GIFT_NOTE_BUTTON).attr('tabindex', isExpanded ? 0 : -1);
    };
    const updateElementsStatus = (textarea)=>{
        const cart_note = String(textarea.val() || '').trim();
        if (cart_note === '') {
            $(GIFT_NOTE_CONTAINER).removeClass('--is-active');
            $(GIFT_NOTE_BUTTON).removeClass('u-vhide');
            $(GIFT_NOTE_TOGGLE).addClass('u-vhide');
            $(GIFT_NOTE_EDIT).addClass('u-vhide');
            $(GIFT_NOTE_NOTICE).addClass('u-vhide');
        } else {
            $(GIFT_NOTE_CONTAINER).toggleClass('--is-active');
            $(GIFT_NOTE_BUTTON).addClass('u-vhide');
            $(GIFT_NOTE_TOGGLE).removeClass('u-vhide');
            $(GIFT_NOTE_EDIT).removeClass('u-vhide');
            $(GIFT_NOTE_NOTICE).removeClass('u-vhide');
            updateTextareaExpanded();
        }
    };
    $(document).ready(function() {
        const $textareas = $(GIFT_NOTE_TEXT_AREA);
        $textareas.each((_, textarea)=>{
            const $textarea = $(textarea);
            const $container = $textarea.closest(GIFT_NOTE_CONTAINER);
            const $counter = $container.find(GIFT_NOTE_TEXT_AREA_COUNTER);
            const maxLength = $counter.data('maxlength');
            const debouncedCheckNote = debounce(()=>checkNote($textarea), 1000);
            $textarea.on('keypress', function(e) {
                if (e.which === 13) {
                    e.preventDefault() // prevent Enter key
                    ;
                }
            });
            // Update counter and check note when typing
            $textarea.on('input', ()=>{
                const length = String($textarea.val() || '').length;
                $counter.text(`${length} / ${maxLength}`);
                debouncedCheckNote();
            });
            // Set initial values
            const currentText = String($textarea.val() || '').trim();
            $textarea.val(currentText);
            $counter.text(`${currentText.length} / ${maxLength}`);
            updateElementsStatus($textarea);
        });
        $(document).on('click', `${GIFT_NOTE_TOGGLE}, ${GIFT_NOTE_EDIT}`, (ev)=>{
            const button = $(ev.currentTarget);
            const textarea = button.parent().find(GIFT_NOTE_TEXT_AREA);
            updateElementsStatus(textarea);
            textarea.blur();
            textarea.focus();
        });
        $(GIFT_NOTE_BUTTON).on('click', ()=>{
            $(GIFT_NOTE_CONTAINER).addClass('--is-active');
            $(GIFT_NOTE_BUTTON).addClass('u-vhide');
            $(GIFT_NOTE_TOGGLE).removeClass('u-vhide');
            $(GIFT_NOTE_TEXT_AREA).focus();
            updateTextareaExpanded();
        });
    });
};
